import styleVariables from '@/styles/style.module.scss';
import { Box, Button, darken } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { TabKey } from '../provider/state';
import { TAB_CONFIG } from '../types';

interface TabsProps {
    activeTab: string;
    setActiveTab: (tab: TabKey) => void;
}
const TAB_TEST_ID_MAP: Record<TabKey, string> = {
    association: 'mobile-tab-association',
    'multi-assoc': 'mobile-tab-multi-assoc',
    deassociation: 'mobile-tab-deassociation',
    'out-of-stock': 'mobile-tab-out-of-stock',
    'led-control': 'mobile-tab-led-control',
    'register-device': 'mobile-tab-register-device',
};

const Tabs: FC<TabsProps> = ({ activeTab, setActiveTab }) => {
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                display: 'flex',
                overflowX: 'auto',
                WebkitOverflowScrolling: 'touch',
                gap: 1,
                px: 2.5,
                pb: 1,
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                scrollbarWidth: 'none',
                '&::-webkit-scrollbar': {
                    display: 'none', // Chrome / Safari / iOS
                },
            }}
        >
            {TAB_CONFIG.map((tab) => {
                const isSelected = tab.key === activeTab;
                return (
                    <Button
                        data-testid={TAB_TEST_ID_MAP[tab.key as TabKey]}
                        id={TAB_TEST_ID_MAP[tab.key as TabKey]}
                        sx={{
                            flex: '0 0 auto',
                            padding: '5px 15px',
                            fontWeight: 'bold',
                            borderRadius: 2,
                            backgroundColor: isSelected ? styleVariables.primaryColor : styleVariables.bgColor1,
                            color: isSelected ? styleVariables.bgColor1 : styleVariables.textColor,
                            border: 'none',
                            whiteSpace: 'nowrap',
                            '&:hover': {
                                backgroundColor: isSelected
                                    ? styleVariables.primaryColor
                                    : darken(styleVariables.bgColor1, 0.05),
                                boxShadow: 'none',
                            },
                        }}
                        key={tab.key}
                        onClick={() => setActiveTab(tab.key as TabKey)}
                    >
                        {t(tab.label)}
                    </Button>
                );
            })}
        </Box>
    );
};

export default Tabs;
